import React, { useState } from 'react';
import { usePatchForm } from '../../providers/PatchFormProvider';

const PatchesAccordion = () => {
  const [open, setOpen] = useState(true);
  const { patchFormData } = usePatchForm();

  return (
    <div className="bg-[#111] text-white rounded-lg p-4">
      <div className="flex justify-between items-center cursor-pointer" onClick={() => setOpen(!open)}>
        <h2 className="font-semibold text-sm">PATCHES AVAILABLE</h2>
        <span>{open ? '▾' : '▸'}</span>
      </div>

      {open && (
        <div className="mt-4">
          <div className="grid grid-cols-5 text-xs font-semibold text-gray-400 px-2 pb-2 border-b border-zinc-700">
            <div>Software Name</div>
            <div>Selected Version</div>
            <div>Patch Type</div>
            {/* <div>CVSS Score</div> */}
            {/* <div>CVE Number</div> */}
            {/* <div>OS Supported</div> */}
            <div>Date Available</div>
            <div>Devices Needing Patch</div>
          </div>

          {patchFormData.RemediationPlanPatchList.map((item, index) => {
            // const percentage = Math.round((item.devicesPatched / item.totalDevices) * 100);
            return (
              <div key={index} className="grid grid-cols-5 items-center text-sm px-2 py-2 rounded-md hover:bg-zinc-800 transition">
                <div>{item.PackageName}</div>
                <div>{item.TargetVersion}</div>
                <div>{item.PatchType}</div>
                {/* <div>{item.cvssScores ? item.cvssScores.map((item) => <p>{item}</p>) : '--'}</div>
                <div>{item.cveNumbers ? item.cveNumbers.map((item) => <p>{item}</p>) : '--'}</div> */}
                {/* <div>Windows</div> */}
                <div>{item.releaseDate}</div>
                <div className="flex flex-col">
                  <div className="relative h-2 bg-gray-700 rounded-full w-full">
                    <div
                      className="absolute top-0 left-0 h-2 bg-green-500 rounded-full"
                      style={{
                        width: `${((item.numberOfAgentWithThisPackageIdentifier - item.numberOfAgentWithThisPackageIdentifierAndVersion) / item.numberOfAgentWithThisPackageIdentifier) * 100}%`,
                      }}
                    />
                  </div>
                  <span className="text-xs mt-1">
                    {item.numberOfAgentWithThisPackageIdentifier - item.numberOfAgentWithThisPackageIdentifierAndVersion}/
                    {item.numberOfAgentWithThisPackageIdentifier}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PatchesAccordion;
